module.exports = __webpack_public_path__ + "img/transparent_200x200.png";


//////////////////
// WEBPACK FOOTER
// ./components/projects/project/img/transparent_200x200.png
// module id = ./components/projects/project/img/transparent_200x200.png
// module chunks = 0